import { useEffect, useRef, useState } from "react";
import API from "../../Api/axiosConfig";
import { Row, Col, Spinner, Card, Button } from "react-bootstrap";
import MyInput from "../../Components/Myinput";
import ToggleSwitch from "../../Components/ToggleSwitch";
import MyButton from "../../Components/MyButton";
import { toast } from "react-toastify";
import Can from "../../Components/Can";
import { LogIn } from "lucide-react";
import PremiumUploader from "../../Components/PremiumUploader";
import { useAuth } from "../../context/AuthContext";

function Settings() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [deletingLogo, setDeletingLogo] = useState(false);
  const [deletingSeal, setDeletingseal] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [sealPreview, setSealPreview] = useState(null);
  const logoRef = useRef();
  const sealRef = useRef();
  const {handleRefetch} = useAuth()
  // --- ننقل fetchData هنا ---
  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await API.get("/settings");
      setData(res.data.data || {});
      setLogoPreview(res.data.data?.company_logo || null);
      setSealPreview(res.data.data?.company_seal || null);
    } catch (err) {
      console.error("فشل في جلب الإعدادات", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      // --- الشرط الأول: نوع الصورة ---
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
      ];
      if (!allowedTypes.includes(files[0].type)) {
        toast.error("اختر صورة بصيغة JPG أو PNG أو WEBP فقط.");
        return;
      }

      const maxSize = 2 * 1024 * 1024; // 2MB
      if (files[0].size > maxSize) {
        toast.warning("حجم الصورة كبير جدًا. الحد الأقصى هو 2 ميجابايت.");
        return;
      }
      setData((prev) => ({ ...prev, [name]: files[0] }));
      if (name === "company_logo")
        setLogoPreview(URL.createObjectURL(files[0]));
      if (name === "company_seal")
        setSealPreview(URL.createObjectURL(files[0]));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      //  تحقق من القيم السالبة قبل الإرسال
      if (Number(data.tax_percent) < 0) {
        toast.error("لا يمكن إدخال نسبة ضريبة سالبة");
        setSaving(false);
        return;
      }
      const formData = new FormData();

      Object.keys(data).forEach((key) => {
        if (key === "company_logo" || key === "company_seal") {
          if (data[key] instanceof File) formData.append(key, data[key]);
        } else if (data[key] !== null && data[key] !== undefined) {
          //  تحقق عام لأي قيمة رقمية في الإعدادات
          if (
            typeof data[key] === "number" ||
            (!isNaN(data[key]) && data[key] !== "")
          ) {
            if (Number(data.tax_percent) < 0) {
              toast.error("لا يمكن إدخال نسبة ضريبة سالبة");
              setSaving(false);
              return;
            }
          }

          formData.append(key, data[key]);
        }
      });

      await API.post(`/settings/${data.uuid}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      fetchData();
      handleRefetch();
      toast.success("تم تحديث البيانات بنجاح");
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1500);

    } catch (err) {
      console.error("فشل في تحديث الإعدادات", err);
      toast.error("فشل الحفظ");
    } finally {
      setSaving(false);
    }
  };

  const handleDeleteLogo = async () => {
    setLogoPreview(null);
    setDeletingLogo(true);
    //     setData((prev) => ({
    //   ...prev,
    //   company_logo: null,
    // }));
    try {
      await API.delete(`settings/${data.uuid}/delete-images?delete_logo=1`);
    } catch (erorr) {
      console.error("error", erorr);
    } finally {
      setDeletingLogo(false);
    }
  };

  // console.log(data);
  // if (!logoPreview && !sealPreview) {
  //   await API.delete(`settings/${data.uuid}/delete-images?logo=1&seal=1`);
  // } else if (!logoPreview) {
  //   await API.delete(`settings/${data.uuid}/delete-images?logo=1`);
  // } else if (!sealPreview) {
  //   await API.delete(`settings/${data.uuid}/delete-images?seal=1`);
  // }
  const handleDeleteSeal = async () => {
    setSealPreview(null);
    setDeletingseal(true);
    try {
      await API.delete(`settings/${data.uuid}/delete-images?delete_seal=1`);
    } catch (erorr) {
      console.error("error", erorr);
    } finally {
      setDeletingseal(false);
    }
    //     setData((prev) => ({
    //   ...prev,
    //   company_seal: null,
    // }));
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <Spinner animation="border" style={{ color: "white" }} />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="p-3 settings-form" dir="rtl">
      <Card className="shadow-sm p-3 mb-3">
        <h5 className="mb-3 text-primary fw-bold">إعدادات الشركة</h5>
        <Row>
          <Col md={6}>
            <MyInput
              label="اسم الشركة"
              type="text"
              name="company_name"
              value={data.company_name || ""}
              onChange={handleChange}
            />
            <MyInput
              label="العنوان"
              type="text"
              name="company_address"
              value={data.company_address || ""}
              onChange={handleChange}
            />
            <MyInput
              label="رقم الهاتف"
              type="text"
              name="company_phone"
              value={data.company_phone || ""}
              onChange={handleChange}
            />
            <MyInput
              label="الموقع الإلكتروني"
              type="text"
              name="company_website"
              value={data.company_website || ""}
              onChange={handleChange}
            />
          </Col>
          <Col md={6}>
            <MyInput
              label="البريد الإلكتروني"
              type="email"
              name="company_email"
              value={data.company_email || ""}
              onChange={handleChange}
            />
            <MyInput
              label="السجل التجاري"
              type="text"
              name="company_commercial"
              value={data.company_commercial || ""}
              onChange={handleChange}
            />
            <MyInput
              label="الرقم الضريبي"
              type="text"
              name="company_tax_number"
              value={data.company_tax_number || ""}
              onChange={handleChange}
            />
            <MyInput
              label="ملاحظات الفاتورة"
              type="text"
              name="footer_note"
              value={data.footer_note || ""}
              onChange={handleChange}
            />
            {/* {console.log(Number(data.tax_percent))
            } */}
            <MyInput
              label="نسبة الضريبة"
              type="number"
              name="tax_percent"
              value={Number(data.tax_percent) || 0}
              onChange={handleChange}
              percent={true}
            />
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm p-3 mb-3">
        <Row>
          <Col md={6} className="d-flex justify-content-center">
            {/* <label className="form-label small">شعار الشركة</label>
            <input
              type="file"
              name="company_logo"
              onChange={handleFileChange}
              className="form-control form-control-sm"
              accept="image/png, image/jpeg, image/jpg, image/webp"
            />
            {logoPreview && (
              <div className="mt-2 text-center">
                <img
                  src={logoPreview}
                  alt="شعار"
                  className="rounded border"
                  style={{ maxWidth: "120px" }}
                />
                <br />
                <button
                  className="btn delete-img btn-sm btn-danger mt-2"
                  onClick={handleDeleteLogo} // عند الضغط على زر الحذف
                  load
                >
                  حذف الشعار
                </button>
              </div>
            )} */}
            <PremiumUploader
              title="شعار الشركة"
              name="company_logo"
              preview={logoPreview}
              onDelete={handleDeleteLogo}
              onChange={handleFileChange}
              inputRef={logoRef}
              accept="image/png, image/jpeg, image/jpg, image/webp"
            />
          </Col>
          <Col md={6} className="d-flex justify-content-center">
            {/* <label className="form-label small">الختم</label>
            <input
              type="file"
              name="company_seal"
              onChange={handleFileChange}
              className="form-control form-control-sm"
            />
            {sealPreview && (
              <div className="mt-2 text-center">
                <img
                  src={sealPreview}
                  alt="ختم"
                  className="rounded border"
                  style={{ maxWidth: "120px" }}
                />
                <br />
                <button
                  type="button"
                  className="btn delete-img btn-sm btn-danger mt-2"
                  onClick={handleDeleteSeal} // عند الضغط على زر الحذف
                >
                  حذف الختم
                </button>
              </div>
            )} */}
            <PremiumUploader
              title="الختم"
              name="company_seal"
              preview={sealPreview}
              onDelete={handleDeleteSeal}
              onChange={handleFileChange}
              inputRef={sealRef}
              accept="image/png, image/jpeg, image/jpg, image/webp"
            />
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm p-3 mb-3">
        <h6 className="mb-3 text-secondary">مكونات إضافية للفاتورة</h6>
        <Row>
          <Col xs={12}>
            <ToggleSwitch
              label="إظهار انواع التراخيص عند إنشاء فاتورة"
              name="licence_type"
              className="additional"
              checked={data.licence_type}
              onChange={handleChange}
            />
          </Col>
          <Col xs={12} md={6}>
            <MyInput
              label="الحقل رقم 1"
              type="text"
              name="string_1"
              value={data.string_1 || ""}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <ToggleSwitch
              label="إظهار الحقل رقم 1"
              name="bool_1"
              className="additional"
              checked={data.bool_1}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <MyInput
              label="الحقل رقم 2"
              type="text"
              name="string_2"
              value={data.string_2 || ""}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <ToggleSwitch
              label="إظهار الحقل رقم 2"
              name="bool_2"
              className="additional"
              checked={data.bool_2}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <MyInput
              label="الحقل رقم 3"
              type="text"
              name="string_3"
              value={data.string_3 || ""}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <ToggleSwitch
              label="إظهار الحقل رقم 3"
              name="bool_3"
              className="additional"
              checked={data.bool_3}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <MyInput
              label="الحقل رقم 4"
              type="text"
              name="string_4"
              value={data.string_4 || ""}
              onChange={handleChange}
            />
          </Col>

          <Col xs={12} md={6}>
            <ToggleSwitch
              label="إظهار الحقل رقم 4"
              name="bool_4"
              className="additional"
              checked={data.bool_4}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Card>
      <Card className="shadow-sm p-3 mb-3">
        <h6 className="mb-3 text-secondary">خيارات رأس الفاتورة</h6>
        <Row>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="اسم الشركة"
              name="head_company_name"
              checked={data.head_company_name}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="نوع الفاتورة"
              name="head_invoice_type"
              checked={data.head_invoice_type}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="العنوان"
              name="head_invoice_address"
              checked={data.head_invoice_address}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="رقم الفاتورة"
              name="head_invoice_number"
              checked={data.head_invoice_number}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="اسم العميل"
              name="head_customer_name"
              checked={data.head_customer_name}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="شعار الشركة"
              name="head_company_logo"
              checked={data.head_company_logo}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Card>

      <Card className="shadow-sm p-3 mb-3">
        <h6 className="mb-3 text-secondary">خيارات تذييل الفاتورة</h6>
        <Row>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="الرقم الضريبي"
              name="foot_tax_number"
              checked={data.foot_tax_number}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="السجل التجاري"
              name="foot_company_commercial"
              checked={data.foot_company_commercial}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="البريد الإلكتروني"
              name="foot_company_email"
              checked={data.foot_company_email}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="الموقع الإلكتروني"
              name="foot_company_website"
              checked={data.foot_company_website}
              onChange={handleChange}
            />
          </Col>
          <Col xs={6} md={4}>
            <ToggleSwitch
              label="الختم"
              name="foot_company_seal"
              checked={data.foot_company_seal}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Card>
      <Can permission="setting_update">
        <div className="text-center">
          <MyButton text="حفظ" loading={saving} className="save" />
        </div>
      </Can>
    </form>
  );
}

export default Settings;
